import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { IdentityDecision } from './identity-decision.entity';

export class CreateIdentityDecisionDto extends Omit(IdentityDecision, [...BaseEntityFieldsArray, 'status', 'decisionSource'], ['status', 'decisionSource']) {
    status?: IdentityDecision['status'];
    decisionSource?: IdentityDecision['decisionSource'];
}
